import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'parseBase64',
  standalone: true,
})
export class ParseBase64Pipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(base64Img?: string, type = 'image/jpg'): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `data:${type};base64,` + base64Img,
    );
  }
}
